import { render, staticRenderFns } from "./ImportAlumniMember.vue?vue&type=template&id=719a3083&"
import script from "./ImportAlumniMember.vue?vue&type=script&lang=js&"
export * from "./ImportAlumniMember.vue?vue&type=script&lang=js&"
import style0 from "./ImportAlumniMember.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports